export const getCertificationUploadPhotoTourPage = t => [
  {
    target: '[data-tour="submissionWizard"]',
    message: t('demoTour.submissionWizard'),
  },
  {
    target: '[data-tour="submissionSteps"]',
    message: t('demoTour.submissionSteps'),
  },
  {
    target: '[data-tour="submissionStepsInfo"]',
    message: t('demoTour.submissionStepsInfo'),
  },
  {
    target: '[data-tour="submissionRequiredOptional"]',
    message: t('demoTour.submissionRequiredOptional'),
  },
  {
    target: '[data-tour="submissionRequiredDropdown"]',
    message: t('demoTour.submissionRequiredDropdown'),
  },
  {
    target: '[data-tour="submissionRequiredTag"]',
    message: t('demoTour.submissionRequiredTag'),
  },
];
